import { render, staticRenderFns } from "./RenewModal.vue?vue&type=template&id=456b3319&scoped=true&"
import script from "./RenewModal.vue?vue&type=script&lang=js&"
export * from "./RenewModal.vue?vue&type=script&lang=js&"
import style0 from "./RenewModal.vue?vue&type=style&index=0&id=456b3319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456b3319",
  null
  
)

export default component.exports